import React, { useState, useEffect, useRef } from 'react';
import { post, isAuthenticated } from '../utils/api';
import { useNavigate } from 'react-router-dom';
import './css/ContactUs.css';
import GradientButton from '../components/GradientButton';

const ContactUs = () => {
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState('');
  const [message, setMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const isUserLoggedIn = isAuthenticated();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await post('/api/submit-feedback/', { email, feedback });
      setMessage('您的信息我们已收到，如有需要我们会通过站内信或邮箱联系您，衷心感谢您的反馈！');
      setEmail('');
      setFeedback('');
      setShowPopup(true);
    } catch (error) {
      setMessage('发生错误，请稍后再试。');
    }
  };

  const modalRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && showPopup) {
        handlePopupClose();
      }
    };

    if (showPopup) {
      document.addEventListener('keydown', handleEscape);
      // Focus the button when modal opens
      if (buttonRef.current) {
        buttonRef.current.focus();
      }
      // Disable scrolling on body
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      // Re-enable scrolling when component unmounts or modal closes
      document.body.style.overflow = 'auto';
    };
  }, [showPopup]);

  const handlePopupClose = () => {
    setShowPopup(false);
    navigate('/');
  };

  return (
    <div className="contact-us-container">
      <h2>联系我们</h2>
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="email">电子邮箱（选填）：</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="feedback">反馈意见：</label>
          <textarea
            id="feedback"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            required
            placeholder="您对猫咪家有什么想法及建议？期待您告诉我们"
          />
        </div>
        <button type="submit" className="submit-button">提交</button>
      </form>
      
      {showPopup && (
        <div 
          className="feedback-popup-overlay"
          onClick={(e) => {
            // Close modal when clicking on the overlay (outside the modal)
            if (e.target === e.currentTarget) {
              handlePopupClose();
            }
          }}
        >
          <div 
            className="feedback-popup"
            role="dialog"
            aria-modal="true"
            aria-labelledby="feedback-modal-title"
            ref={modalRef}
          >
            <button 
              className="close-modal-button" 
              onClick={handlePopupClose}
              aria-label="关闭"
            >
              &times;
            </button>
            <h3 id="feedback-modal-title">提交成功</h3>
            <p>{message}</p>
            <GradientButton 
              onClick={handlePopupClose} 
              className="popup-button"
              ref={buttonRef}
            >
              确定
            </GradientButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
